import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "../../utils";
import FollowHandler from "./FollowHandler";
import { NavLink } from "react-router-dom";

const FriendsHint = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [playOnce, setPlayOnce] = useState(true);
  const [friendsHint, setFriendsHint] = useState([]);
  const userData = useSelector((state) => state.rootReducer.userReducer.user);
  const usersData = useSelector((state) => state.rootReducer.usersReducer.users);

  useEffect(() => {
    const notFriendList = () => {
      let array = [];
      usersData.map((user) => {
        let renvoyer;
        if (user._id !== userData._id && !user.followers.includes(userData._id)){
          renvoyer = array.push(user._id); 
        }
        return renvoyer;
      });
      array.sort(() => 0.5 - Math.random());
      if (window.innerHeight > 780) {
        array.length = 5;
      } else if (window.innerHeight > 720) {
        array.length = 4;
      } else if (window.innerHeight > 615) {
        array.length = 3;
      } else if (window.innerHeight > 540) {
        array.length = 1;
      } else {
        array.length = 0;
      }
      setFriendsHint(array);
    };

    if (playOnce && !isEmpty(usersData[0]) && !isEmpty(userData._id)) {
      notFriendList();
      setIsLoading(false);
      setPlayOnce(false);
    }
  }, [usersData, userData, playOnce]);

  return (
    <div className="get-friends-container">
      <h4>Suggestions</h4>
      {isLoading ? (
        <div className="icon">
          <i className="fas fa-spinner fa-pulse"></i>
        </div>
      ) : (
        <ul>
          {friendsHint &&
            friendsHint.map((user) => {
              let renvoyer;
              for (let i = 0; i < usersData.length; i++) {
                if (user === usersData[i]._id) {
                  renvoyer = (
                    <li className="user-hint" key={user}>
                      <NavLink exact="true" to={{
                        pathname:'/user/'+ usersData[i]._id,
                      }}>
                        <img src={usersData[i].picture} alt="user-pic" />
                      </NavLink>
                      <p>{usersData[i].pseudo}</p>
                      <FollowHandler
                        idToFollow={usersData[i]._id}
                        type={"suggestion"}
                      />
                    </li>
                  );
                }
              }
              return renvoyer;
            })}
        </ul>
      )}
    </div>
  );
};

export default FriendsHint;
